import angular = require('angular');
import * as ths from '../helpers/templateHelperService';

// TODO: implement SharePoint Search for documents

interface IMaterialDetailviewControllerScope extends ng.IScope {
	vm: MaterialDetailviewController,
	product: any
}

export class MaterialDetailviewController {
	public static $inject = [`$scope`, `$log`, `$timeout`, `$templateRequest`, `$compile`, `$element`, `templateHelperService`, `_lumasContext`];
	public constructor(private $scope: IMaterialDetailviewControllerScope,
		private $log: ng.ILogService,
		private $timeout: ng.ITimeoutService,
		private $templateRequest: ng.ITemplateRequestService,
		private $compile: ng.ICompileService,
		private $element,
		private templateHelperService: ths.TemplateHelperService,
		private _lumasContext: any,
	) {
		$scope.vm = this;
	}

	public show: boolean = false;
	private templateAppended: boolean = false;
	public appData: any;
	public portalConfig: any;
	public pdfFormat: string = "ISO";
	public pdfLanguage: string = "en";
	public showPDFDownload: boolean = false;

	public showModal() {
		var self = this;
		self.show = true;
		if (!self.templateAppended) {
			var templateUrl = this.templateHelperService.getTemplateUrl('modalWindow.html');
			self.$templateRequest(templateUrl)
				.then(function (html) {
					var template = angular.element(html);
					self.$element.parent().append(template);
					self.$compile(template)(self.$scope);
					self.appData = (self.$scope.$parent as IMaterialDetailviewControllerScope).vm.appData;
					self.portalConfig = window["Ll"].PortalConfig;
				});
			self.templateAppended = true;
		}
	}
	public startPDFDownload(itemProductCode) {
		var self = this;
		//self.show = false;
		self.showPDFDownload = false;

		window.open(
			self._lumasContext.svcBaseUrl + 'gettdsfile/' + itemProductCode + '/' + self.pdfLanguage + '/' + self.pdfFormat);
	}
	public openPopup(url) {
		EnsureScriptFunc('sp.ui.dialog.js');
		ExecuteOrDelayUntilScriptLoaded(function () {
			alert('ready for dialog from ' + url);
		}, 'sp.ui.dialog.js');
	}
}

export class MaterialDetailview implements ng.IDirective {
	public replace = true;
	public restict = `E`;

	public template = `<a class="llLink" ng-click="vm.showModal()">{{item.Name ? item.Name : product}}</a>`;
	public controller = `materialDetailviewController`;
	public controllerAs = `vm`;
	public scope = {
		item: '='
	}
}